// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__L0-Zv","icon":"style_icon__2mITw","rotate":"style_rotate__2a-ap"};